import {
  LoadSpacingConfiguration,
  LoadSpacingForm,
  SpacingOrFlowRate,
  TimeOnJobSite
} from '../../../fields/loadSpacing/types'
import {CreateFormInput} from '../types'

export const buildLoadSpacingForm = ({
  configuration
}: CreateFormInput<LoadSpacingConfiguration>): LoadSpacingForm => {
  // Initialize form with proper default values based on configuration
  let defaultSpacingOrFlowRate: SpacingOrFlowRate | undefined = undefined
  let defaultTimeOnJobSite: TimeOnJobSite | undefined = undefined

  if (configuration.loadSpacing.isEnabled) {
    const singleTruckScenario = configuration.loadSpacing.scenarios.singleTruck
    const multipleTruckScenario = configuration.loadSpacing.scenarios.multipleTrucks

    // Set default spacing or flow rate based on scenario
    if (multipleTruckScenario.loadSpace && configuration.loadSpacing.loadSpace) {
      defaultSpacingOrFlowRate = {
        type: 'loadSpace',
        loadSpace: configuration.loadSpacing.loadSpace.default,
        loadSpaceUom: configuration.loadSpacing.loadSpace.uom
      }
    } else if (multipleTruckScenario.flowRate && configuration.loadSpacing.flowRate) {
      defaultSpacingOrFlowRate = {
        type: 'flowRate',
        flowRate: configuration.loadSpacing.flowRate.default,
        flowRateUom: configuration.loadSpacing.flowRate.uom
      }
    }

    // Set default time on job site if the scenario requires it
    if (singleTruckScenario.timeOnJobSite && configuration.loadSpacing.timeOnJobSite) {
      defaultTimeOnJobSite = {
        time: configuration.loadSpacing.timeOnJobSite.default,
        timeUom: configuration.loadSpacing.timeOnJobSite.uom
      }
    }
  }

  return {
    spacingOrFlowRate: defaultSpacingOrFlowRate,
    timeOnJobSite: defaultTimeOnJobSite
  }
}
